<ng-template [ngIf]="isLoadingResults">
  <app-loading></app-loading>
</ng-template>
<div >
  <p-timeline [value]="storico">
     <ng-template pTemplate="marker" let-recordoStorico>
      <span
        class="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1 material-symbols-outlined small-icon"
        [ngClass]="stiliService.getMaterialIconStoricoOda(recordoStorico.operazione)"
        [style]="{ 'background-color': stiliService.getColoreIconaStoricoOda(recordoStorico.operazione) }">
        {{ stiliService.getMaterialIconStoricoOda(recordoStorico.operazione) }}
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-recordoStorico>
      <div class="flex items-center h-full">
        <span class="font-['Poppins'] mt-1 font-semibold">{{ utilService.formattaDataDaDate(recordoStorico.data) }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="opposite" let-recordoStorico>
      <span style="font-weight: bold;" class="mt-2 font-['Poppins']"
        [style]="{ 'color': stiliService.getColoreIconaStoricoOda(recordoStorico.operazione) }">
        {{ 
        formattaStorico(recordoStorico)
        }}</span>
        <br>
       
       
    </ng-template>  
  </p-timeline>
  <div class="border-top-1 surface-border mt-2 mb-2 flex justify-center" style="justify-content: center;">
    <button pButton pRipple icon="pi pi-cloud-download" (click)="scaricaReportStorico()" label="SCARICA" class="mt-2 mr-2 p-button-outlined font-['Poppins']" 
      style="color: #2B4162; background-color: #E9F7CA; border-color: #2B4162;"></button>
    <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="mt-2 p-button-outlined font-['Poppins']" 
      style="color: #2B4162; background-color: #C6D8AF; border-color: #2B4162;"></button>
  </div>
  <div>
